import i18n from "utils/i18n";
import axiosClient from "./axiosClient";
import urlApi from "./url";
// In-flight promise cache to deduplicate simultaneous requests to getWhatYouNeed
const inFlightRequests = new Map();

const buildCacheKey = (params) => {
  try {
    const sortedKeys = Object.keys(params || {}).sort();
    const normalized = {};
    for (const key of sortedKeys) {
      if (params[key] !== undefined) {
        normalized[key] = params[key];
      }
    }
    const token = localStorage.getItem("token") || "";
    return `${token}_${JSON.stringify(normalized)}`;
  } catch (e) {
    return "";
  }
};

const getWhatYouNeedWithCache = (params) => {
  const lang =
    i18n?.language === "en-US" || !i18n?.language ? "en" : i18n?.language;
  const fullParams = {
    ...params,
    lang,
  };

  const cacheKey = buildCacheKey(fullParams);

  if (cacheKey && inFlightRequests.has(cacheKey)) {
    return inFlightRequests.get(cacheKey);
  }

  const promise = axiosClient
    .get(`${urlApi.shared.getWhatYouNeed}`, {
      params: fullParams,
    })
    .then((res) => {
      if (cacheKey) {
        setTimeout(() => {
          if (inFlightRequests.get(cacheKey) === promise) {
            inFlightRequests.delete(cacheKey);
          }
        }, 1000);
      }
      return res;
    })
    .catch((error) => {
      if (cacheKey) {
        inFlightRequests.delete(cacheKey);
      }
      throw error;
    });

  if (cacheKey) {
    inFlightRequests.set(cacheKey, promise);
  }

  return promise;
};

const whatYouNeedApi = {
  whatYouNeed: (params) => {
    return getWhatYouNeedWithCache(params);
  },
  redeemPoints: (params) => {
    return axiosClient.get(`${urlApi.user.redeemPoints}`, {
      params: {
        ...params,
        lang:
          i18n?.language === "en-US" || !i18n?.language ? "en" : i18n?.language,
      },
    });
  },
  rewardMissions: () => {
    return axiosClient.get(`${urlApi.reward.missions}`, {
      params: {
        lang:
          i18n?.language === "en-US" || !i18n?.language ? "en" : i18n?.language,
      },
    });
  },
};

export default whatYouNeedApi;
